import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { OCCASION_TILES } from "../../content";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToId } from "../../lib/api";

const PhotoTile = ({ t, onPick }) => (
  <motion.button
    whileHover="hover"
    data-testid={`occasion-${t.id}`}
    aria-label={`Book a ${t.occasion} sign`}
    onClick={() => onPick(t.occasion)}
    className={`group relative text-left sticker rounded-[28px] overflow-hidden h-[300px] md:h-auto cursor-pointer ${t.span}`}
  >
    <motion.img
      variants={{ hover: { scale: 1.08 } }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      src={t.img}
      alt={`${t.label} yard sign on a lawn`}
      className={`absolute inset-0 w-full h-full object-cover ${t.pos}`}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[rgba(27,26,46,0.75)] via-transparent to-transparent" />
    <div className="absolute left-5 right-5 bottom-5 flex items-end justify-between">
      <div>
        <h3 className="font-display font-bold text-white text-3xl sm:text-4xl">{t.label}</h3>
        <p className="text-white/90 text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          Tap to book this sign
        </p>
      </div>
      <motion.span
        variants={{ hover: { rotate: 45, scale: 1.1 } }}
        className="sticker-sm w-12 h-12 rounded-full bg-[var(--sun)] grid place-items-center"
      >
        <ArrowUpRight size={22} />
      </motion.span>
    </div>
  </motion.button>
);

export const Occasions = ({ onPick }) => {
  const pickCustom = () => onPick("Something Else");
  return (
    <section id="signs" data-testid="signs-section" className="py-24 md:py-32 bg-[var(--paper)] border-y-[3px] border-[var(--ink)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <Eyebrow color="var(--sky)">The signs</Eyebrow>
            <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[0.95]">
              A sign for every kind of hooray.
            </h2>
          </div>
          <p className="font-hand text-2xl text-[var(--ink-soft)] max-w-xs md:text-right">tap a sign to book it</p>
        </Reveal>
        <Reveal className="mt-14">
          <div className="grid grid-cols-1 md:grid-cols-6 md:auto-rows-[230px] gap-6">
            {OCCASION_TILES.map((t) => <PhotoTile key={t.id} t={t} onPick={onPick} />)}
            <motion.button
              whileHover={{ y: -6, rotate: -1 }}
              whileTap={{ scale: 0.98 }}
              data-testid="occasion-custom"
              onClick={pickCustom}
              className="sticker rounded-[28px] bg-[var(--grape)] text-white p-7 text-left flex flex-col justify-between h-[300px] md:h-auto md:col-span-3"
            >
              <div>
                <h3 className="font-display font-bold text-3xl">Welcome home & more</h3>
                <p className="mt-1 text-white/90">Retirements, big wins, "just because." Tell us your idea.</p>
              </div>
              <span className="sticker-sm w-12 h-12 rounded-full bg-[var(--sun)] grid place-items-center self-end">
                <ArrowUpRight size={22} />
              </span>
            </motion.button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
